import axios from 'axios'
import { toast } from 'react-toastify'
import { useReducer } from 'react'
import { LOADING_STARTS, LOADING_STOPS } from '../../../services/types/LoadingTypes'
import scheduleReducer from '../../reducers/schedule/scheduleReducer'
import { LOGIN_URL } from '../../../services/apis/SchedulerUrl'
import { SCHEDULE_SUCCESS } from '../../../services/types/SchedulerTypes'
import Swal from 'sweetalert2'
import { useLocation } from 'react-router-dom'

// CommonJS

const useSchedule = (history) => {
  const [{ token, isLoading, load }, dispatch] = useReducer(scheduleReducer, {
    isLoading: false,
    load: false,
    token: ' ',
  })

  const Swal = require('sweetalert2')

  const Schedule = async (data) => {
    dispatch({ type: LOADING_STARTS })
    const config = {
      method: 'post',
      url: `https://api.tizeti.com/api/v1/installation`,
      data,
      headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    }

    await axios(config)
      .then((response) => {
        if (response.data.id) {
          // console.log('true');

          // toast.success('Scheduling Successful');
          Swal.fire({
            title: 'Scheduling Successful!',
            text: 'We have recieved your schedule and other information. A member of our team will contact you very soon! Thank you.',
            icon: 'success',
            confirmButtonColor: '#1ac9d8',
          })

          setTimeout(() => {
            window.location.replace('https://wifi.com.ng/newuser/#/')
          }, 3000)
          // setTimeout(() => {
          //   history.push({
          //     pathname: `/`,

          //   });
          // });
        }
      })
      .catch((error) => {
        if (error) {
          toast.info('Something went wrong!')
          dispatch({ type: LOADING_STOPS })
        }
      })
  }

  return {
    Schedule,
    isLoading,
    load,

    token,
  }
}

export default useSchedule
